import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { sortBy as _sortBy } from 'lodash';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

import { Currency, Box } from '@app/definitions/interfaces';
import { TeacherService } from '@app/teacher/services/teacher.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
    selector: 'app-common-table',
    templateUrl: './common-table.component.html',
    styleUrls: ['./common-table.component.scss']
})
export class CommonTableComponent implements OnInit, OnDestroy {
    public modalRef: BsModalRef;
    boxes: any[] = [];
    student_results: any[] = [];
    boxId: number;
    studentId: number;
    currency: Currency;
    allAbsent;
    commonData = null;
    studentsAmount: number[] = [];
    studentsCorrectExercises: number[] = [];
    studentsErrorProcents: number[] = [];
    defaultCountTops = 4;

    private destroy$: Subject<boolean> = new Subject<boolean>();

    constructor(
        private route: ActivatedRoute,
        private teacherService: TeacherService,
        private router: Router,
        private modalService: BsModalService
    ) {}

    ngOnInit(): void {
        this.route.parent.params.pipe(takeUntil(this.destroy$)).subscribe(params => {
            const lesson_id = params['lesson_id'];
            if (!!lesson_id) {
                this.teacherService
                    .getAnalytics(lesson_id)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe(response => {
                        this.commonData = response;
                        this.boxes = _sortBy(response.boxes, ['level', 'title']);
                        this.student_results = response.student_results;
                        this.currency = response.currency;

                        this.student_results.sort((student1, student2): number => {
                            return student1.surname > student2.surname ? 1 : -1;
                        });
                        this.allAbsent = true;
                        this.ifStudentsAbsent(this.student_results);
                        this.getTopsData();
                    });
            }
        });
    }

    getTopsData() {
        // получаю списки тех показателей которые нужны для проверки топов
        this.student_results.forEach(item => {
            if (item.lesson_amount_stat_for_student) {
                const studentReward = item.lesson_amount_stat_for_student.total_currencies_amount;
                this.studentsAmount.push(studentReward);
            }
            if (item.lesson_statistics) {
                const totalCorrect = item.lesson_statistics.total_correct_exercises_per_lesson;
                const errorProcent = item.lesson_statistics.error_percent_per_lesson;
                this.studentsCorrectExercises.push(totalCorrect);
                this.studentsErrorProcents.push(errorProcent);
            }
        });
    }

    getChackTops(topsList: number[], someItem: number) {
        // получает мимнимальные и максимальные значения для топов
        // в заданном кол-ве и возвращает наличие (boolean) цифры в топе
        const tops = _sortBy(topsList).slice(-this.defaultCountTops);
        const mins = _sortBy(topsList).slice(0, this.defaultCountTops);
        const isTop = tops.some(item => item === someItem);
        const isMin = mins.some(item => item === someItem);

        return { isTop: isTop, isMin: isMin };
    }

    ngOnDestroy(): void {
        this.allAbsent = false;
        this.destroy$.next(true);
    }

    getData(id, student_box_data): string {
        if (!(student_box_data && student_box_data.length > 0)) {
            return '';
        }

        for (let i = 0; i < student_box_data.length; i++) {
            if (student_box_data[i].box.id === id) {
                if (
                    student_box_data[i].total_incorrect_exercises === undefined ||
                    student_box_data[i].total_correct_exercises === undefined
                ) {
                    return '';
                }
                if (student_box_data[i].total_incorrect_exercises === 0) {
                    if (student_box_data[i].total_correct_exercises === 0) {
                        return '';
                    } else {
                        return '' + student_box_data[i].total_correct_exercises;
                    }
                } else {
                    return (
                        '' +
                        student_box_data[i].total_correct_exercises +
                        ' / ' +
                        student_box_data[i].total_incorrect_exercises
                    );
                }
            }
        }
    }

    getPupilStyle(student): string {
        return student.not_absent
            ? 'pupil_name--common-table present--common-table'
            : 'pupil_name--common-table absent--common-table';
    }

    getEmptyCellStyle(id, array): string {
        if (array.length > 0) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].box.id === id) {
                    if (array[i].total_correct_exercises === 0 && array[i].total_incorrect_exercises === 0) {
                        return 'table_cell--common-table empty--common-table';
                    }
                    if (array[i].total_correct_exercises !== 0 || array[i].total_incorrect_exercises !== 0) {
                        return 'table_cell--common-table';
                    }
                }
            }
        }
        return 'table_cell--common-table empty--common-table';
    }

    getSuccessLevelStyle(id, array): string {
        if (array.length > 0) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].box.id === id) {
                    if (array[i].box_solved_confidently) {
                        return 'success_level--common-table';
                    } else {
                        return 'no_level--common-table';
                    }
                }
            }
        } else {
            return 'no_level--common-table';
        }
    }

    getRightStyle(array): string {
        if (array != null) {
            const { isTop, isMin } = this.getChackTops(
                this.studentsCorrectExercises,
                array.total_correct_exercises_per_lesson
            );
            if (isTop) {
                return 'right_amount--common-table best--common-table';
            }
            if (isMin) {
                return 'right_amount--common-table worst--common-table';
            }
        }
        return 'right_amount--common-table';
    }

    getRightData(array): string {
        if (array != null) {
            return '' + array.total_correct_exercises_per_lesson;
        } else {
            return '';
        }
    }

    getErrorPercentStyle(array): string {
        if (array != null) {
            const { isTop } = this.getChackTops(this.studentsErrorProcents, array.error_percent_per_lesson);
            if (isTop) {
                return 'percent_error--common-table best--common-table';
            }
            return 'percent_error--common-table';
        }
    }

    getErrorPercentData(array): string {
        if (array != null) {
            return '' + Math.round(array.error_percent_per_lesson * 100) / 100;
        } else {
            return '';
        }
    }

    getMoneyStyle(amount): string {
        if (amount != null) {
            const { isTop, isMin } = this.getChackTops(this.studentsAmount, amount.total_currencies_amount);
            if (isTop) {
                return 'money--common-table best--common-table';
            }
            if (isMin) {
                return 'money--common-table worst--common-table';
            }
        }
        return 'money--common-table';
    }

    getMoneyData(student) {
        if (student.not_absent) {
            if (student.lesson_amount_stat_for_student != null) {
                const amount_in_kayros = parseFloat(student.lesson_amount_stat_for_student.total_currencies_amount);
                return `${amount_in_kayros}`;
            } else {
                return '0';
            }
        } else {
            return '';
        }
    }

    showModal(template: TemplateRef<any>, id, array, student) {
        if (this.getData(id, array) !== '') {
            this.boxId = id;
            this.studentId = student;
            this.modalRef = this.modalService.show(template, Object.assign({}, {}));
        }
    }

    hideModal($event) {
        if ($event) {
            this.boxId = null;
            this.studentId = null;
            this.modalRef.hide();
        }
    }

    navigateToPupil(student) {
        if (student.not_absent) {
            this.teacherService.choosePupil(student);
            this.router.navigate(['../individual'], { relativeTo: this.route });
        }
    }

    ifStudentsAbsent(studentResults) {
        for (const student of studentResults) {
            if (student.not_absent) {
                this.allAbsent = false;
                break;
            }
        }
        return this.allAbsent;
    }

    getExtraData(extraExercise) {
        if (!extraExercise) {
            return '-';
        }
        if (extraExercise.count_incorrect === 0) {
            return extraExercise.count_correct;
        }
        return extraExercise.count_correct + '/' + extraExercise.count_incorrect;
    }

    checkBoxForExtraExercise(box: Box) {
        let result = false;
        for (const elem of this.commonData.student_results) {
            result = elem.box_data
                .filter(({ is_lesson_extra_exercise }) => !!is_lesson_extra_exercise)
                .some(({ id }) => box.id === id);

            if (result) {
                break;
            }
        }

        return result;
    }
}
